import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import '@/locales/i18n';
import { msalInstance } from '@/app/config/auth/msalInstance';
import { Router } from '@/app/routes';
import { AuthProvider } from '@/auth/AuthProvider';
import { MonitoringService } from '@/common/services/MonitoringService';
import { QueryClientConfig } from '@/common/services/QueryClientConfig';

const client = new QueryClient(QueryClientConfig);

MonitoringService.init();

function App() {
  const [isAuthInitialized, setIsAuthInitialized] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    msalInstance
      .handleRedirectPromise()
      .then(() => {
        setIsAuthInitialized(true);
      })
      .catch((error) => {
        console.error('Redirect handling error:', error);
        setIsAuthInitialized(true);
      });
  }, []);

  if (!isAuthInitialized) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">{t('app.loading')}</p>
        </div>
      </div>
    );
  }

  return (
    <React.StrictMode>
      <AuthProvider>
        <QueryClientProvider client={client}>
          <Router />
        </QueryClientProvider>
      </AuthProvider>
    </React.StrictMode>
  );
}

export default App;
